import { memo, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';

import { Select } from '.';
import { SelectProps } from './mui-interface';

type SelectHookFormProps = SelectProps & {
  name: string;
};

export const SelectHookForm = memo<SelectHookFormProps>(function InputHookForm({
  name,
  defaultValue,
  ...props
}: SelectHookFormProps) {
  const { control } = useFormContext();
  const selectRef = useRef<any>(null);

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState }) => (
        <div>
          {props?.label && (
            <InputLabel htmlFor={name}>{props?.label}</InputLabel>
          )}

          <FormControl
            id={name}
            fullWidth={props?.fullWidth}
            error={!!fieldState.error}
          >
            <Select
              ref={selectRef}
              selected={value}
              onChange={onChange}
              value={value || ''}
              error={!!fieldState.error}
              {...props}
              inputProps={{ 'data-testid': name, ...props?.inputProps }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 360,
                    width: selectRef?.current
                      ? selectRef?.current?.clientWidth + 20
                      : undefined,
                  },
                },
              }}
            />
            {fieldState?.error?.message && (
              <FormHelperText>{fieldState?.error?.message}</FormHelperText>
            )}
          </FormControl>
        </div>
      )}
    />
  );
});
